import { Form } from 'antd';

export const BaseFormList = Form.List;
